import {useContext} from 'react';
import {UseOfContextWithoutProviderError} from '@/types/errors';
import {DocumentUtilsContext} from './document-utils-context';

export const useDocumentUtils = () => {
  const utils = useContext(DocumentUtilsContext);

  if (!utils) {
    throw new UseOfContextWithoutProviderError('DocumentUtils');
  }

  return utils;
};
